module.exports = __webpack_public_path__ + "static/media/wax.3f136581.png";